var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from 'react'; // tslint:disable-line
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('wait-message');
import { breakpoints, theme } from '@shapeable/theme';
import { Loader } from './loader';
export var WaitMessageDefaultProps = {
  loading: true
};
// -------- Styles -------->
var LoaderStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    box-sizing: border-box;\n    padding: ", ";\n    justify-content: center;\n    align-items: center;\n  "], ["\n    font-size: ", ";\n    display: flex;\n    box-sizing: border-box;\n    padding: ", ";\n    justify-content: center;\n    align-items: center;\n  "])), theme.FONT_SIZE(18), theme.UNIT(4))
});
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: auto;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  "], ["\n    height: auto;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  "]))),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 120px;\n  "], ["\n    height: 120px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Loader: styled(Loader)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles)
};
export var WaitMessage = React.forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    loading = props.loading;
  return React.createElement(My.Container, {
    ref: ref
  }, (true || loading) && React.createElement(My.Loader, {
    spinnerSize: 24,
    className: className
  }, children));
});
WaitMessage.defaultProps = WaitMessageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;